import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

function ActiveSmallWindow({ children }) {

    const smallWindowPosition = useSelector(state => state.conf.roomDetail?.small_window_position);

    const windowStyle = useMemo(() => {
        const positionStyle = (() => {
            switch (smallWindowPosition) {
                case 'top-left':
                    return { top: '1em', left: '1em' };
                case 'top-right':
                    return { top: '1em', right: '1em' };
                case 'bottom-left':
                    return { bottom: '1em', left: '1em' };
                case 'bottom-right':
                default:
                    return { bottom: '1em', right: '1em' };
            }
        })();

        return {
            position: 'fixed',
            ...positionStyle,
            zIndex: 9999,
            height: '6.9em',
            width: '12em',
            // height: '9.3em',
            // width: '16em',
            background: '#eeeeee',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        };
    }, [smallWindowPosition]);



    return (<>
        <div className="small-active-window" id="small-active-window" style={windowStyle}>
            {children}
        </div>

    </>
    );
}

export default ActiveSmallWindow